/*
  Enlarged product image = carousel, not a stack.  (Igor 2026-09-08)

  The stock Be-Yours modal renders every media item into
  .product-media-modal__content as a flex COLUMN, so opening it shows all
  21 images in one long scroll. hm-overrides.css turns that container into a
  horizontal scroll-snap track; this file adds the controls that make it
  behave like a carousel:

    - prev / next buttons
    - a "3 / 21" counter
    - left/right arrow keys
    - opens on the image you actually clicked

  Native scroll-snap does the swiping on touch, so there is no gesture code
  here and nothing to fight the browser.

  Defensive on purpose: the modal is a custom element that Shopify upgrades
  after this script runs, and it is re-populated on variant change, so
  everything is looked up lazily and re-run on open.
*/
(function () {
  'use strict';

  var SEL_MODAL = '.product-media-modal';
  var SEL_TRACK = '.product-media-modal__content';

  function items(track) {
    return Array.prototype.filter.call(track.children, function (el) {
      return !el.classList || !el.classList.contains('hm-modal-nav');
    });
  }

  function currentIndex(track) {
    var list = items(track);
    if (!list.length) return 0;
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var centre = el.offsetLeft + el.offsetWidth / 2;
      var d = Math.abs(centre - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  function goTo(track, index, smooth) {
    var list = items(track);
    if (!list.length) return;
    var i = Math.max(0, Math.min(index, list.length - 1));
    var target = list[i];
    // scrollTo on the track, not scrollIntoView, so the page behind never moves
    track.scrollTo({ left: target.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  }

  function build(modal) {
    var track = modal.querySelector(SEL_TRACK);
    if (!track || modal.dataset.hmCarousel === 'on') return;
    modal.dataset.hmCarousel = 'on';

    var host = track.parentElement || modal;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hm-modal-nav hm-modal-nav--prev';
    prev.setAttribute('aria-label', 'Vorige afbeelding');
    prev.innerHTML = '&#8249;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hm-modal-nav hm-modal-nav--next';
    next.setAttribute('aria-label', 'Volgende afbeelding');
    next.innerHTML = '&#8250;';

    var count = document.createElement('div');
    count.className = 'hm-modal-count';
    count.setAttribute('aria-live', 'polite');

    host.appendChild(prev);
    host.appendChild(next);
    host.appendChild(count);

    function sync() {
      var list = items(track);
      var i = currentIndex(track);
      count.textContent = (i + 1) + ' / ' + list.length;
      prev.disabled = i <= 0;
      next.disabled = i >= list.length - 1;
      count.hidden = list.length < 2;
      prev.hidden = list.length < 2;
      next.hidden = list.length < 2;
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      goTo(track, currentIndex(track) - 1);
    });
    next.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      goTo(track, currentIndex(track) + 1);
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(track, currentIndex(track) - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(track, currentIndex(track) + 1); }
    });

    modal.hmSync = sync;
    sync();
  }

  /* Open on the image that was clicked.

     The theme calls show(opener) and then scrolls the matching media into
     view vertically. With a horizontal track that scroll lands in the wrong
     axis, so realign from the media id the opener carries. */
  function alignToOpener(modal, mediaId) {
    var track = modal.querySelector(SEL_TRACK);
    if (!track) return;
    var list = items(track);
    var idx = 0;
    if (mediaId) {
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        var id = el.dataset ? (el.dataset.mediaId || el.getAttribute('data-media-id')) : null;
        if (id && String(id).indexOf(String(mediaId)) !== -1) { idx = i; break; }
      }
    }
    goTo(track, idx, false);
    if (modal.hmSync) modal.hmSync();
  }

  function wire() {
    var modal = document.querySelector(SEL_MODAL);
    if (!modal) return;
    build(modal);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('.product__modal-opener, .product__media-toggle');
      if (!opener) return;
      var holder = opener.closest('[data-media-id]') || opener.querySelector('[data-media-id]');
      var mediaId = holder ? (holder.dataset.mediaId || holder.getAttribute('data-media-id')) : null;
      // let the theme open and populate first
      setTimeout(function () {
        var m = document.querySelector(SEL_MODAL);
        if (!m) return;
        build(m);
        alignToOpener(m, mediaId);
      }, 60);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  // the modal is rebuilt on variant change
  document.addEventListener('shopify:section:load', wire);
})();
